import { clsx, type ClassValue } from "clsx";

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

// clamp + lerp helpers
export const clamp = (n: number, min = 0, max = 1) => Math.min(max, Math.max(min, n));
export const lerp = (a: number, b: number, t: number) => a + (b - a) * t;

// stable-ish id for client-created things
let _id = 0;
export function uid(prefix = "n"): string {
  _id += 1;
  return `${prefix}_${Date.now().toString(36)}_${_id}`;
}
